import styles from './SimpleFooter.module.css'
import { LayoutCenter } from '@betterplace/design-system/server'
import { useTranslations } from 'next-intl'

function SimpleFooter() {
  const t = useTranslations('nextjs.core')

  return (
    <footer className={styles.container}>
      <LayoutCenter centeredChildren>{t('provider_info')}</LayoutCenter>
    </footer>
  )
}

export default SimpleFooter
